import { render } from "./PositionForm.vue?vue&type=template&id=2752485c"
import script from "./PositionForm.vue?vue&type=script&lang=js"
export * from "./PositionForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__